export type DelinquencyConstants = Record<string, string[]>;

export const DEFAULT_DELINQUENCY_STATUS_VALUES: DelinquencyConstants = {
  'Please select': [],
  Delinquent: ['NOD not send', 'NOD Sent'],
  'Pre-Foreclosure': [],
  Foreclosure: [
    'Requires Initiation',
    'With Lawyer',
    'On Hold',
    'Sold at Foreclosure',
    'Paid Off',
  ],
  Bankruptcy: [],
  REO: [],
};

export const DELINQUENCY_TODO_TITLE_SETTLEMENT_DETAILS = 'Settlement Details';
export const DELINQUENCY_TODO_TITLE_TITLE_AGENCY = 'Title Agency';
export const DELINQUENCY_TODO_TITLE_REALIZED_LOSS = 'Realized Principal And Interest Loss';
export const DELINQUENCY_TODO_TITLE_DELINQUENCY_STATUS = 'Delinquency Status And Comments';
export const DELINQUENCY_TODO_TITLE_POST_MORTEM = 'Post-Mortem';
export const DELINQUENCY_TODO_TITLE_PROPERTY_APPRAISALS = 'Property Appraisals';
export const DELINQUENCY_TODO_TITLE_FORECLOSURE_ATTORNEY = 'Foreclosure Attorney';
